import { cva } from 'class-variance-authority';

export const navItemStyles = cva(
  'px-2 py-1.5 text-sm font-semibold text-neutrals-800 hover:bg-neutrals-200 rounded-md transition-colors hover:cursor-pointer',
);
